import { rupees } from "../products/types";
import type { OrderTotals } from "./types";

interface OrderTotalsBreakdownProps {
  totals: OrderTotals;
  /** e.g. "Total payable" before paying, "Total paid" after. */
  totalLabel: string;
}

/** Subtotal, GST and total, as rows. */
export function OrderTotalsBreakdown({ totals, totalLabel }: OrderTotalsBreakdownProps) {
  return (
    <dl className="space-y-2 text-sm" aria-label="Order totals">
      <div className="flex justify-between text-ink-2">
        <dt>Subtotal</dt>
        <dd className="tabular-nums">{rupees(totals.subtotal)}</dd>
      </div>
      <div className="flex justify-between text-ink-2">
        <dt>GST ({totals.gst_rate_percent}%)</dt>
        <dd className="tabular-nums">{rupees(totals.gst_amount)}</dd>
      </div>
      <div className="flex justify-between border-t border-line pt-3 text-base font-bold text-ink">
        <dt>{totalLabel}</dt>
        <dd className="tabular-nums">{rupees(totals.total)}</dd>
      </div>
    </dl>
  );
}
